import { IconButton, MenuItem, Popover } from '@mui/material';
import Iconify from '../iconify';

interface ActionButtonProps {
  id: string;
  onClick: (event: any) => void;
  open: any;
  setEditItemId: (id: number) => void;
  setDeleteItemId: (id: number) => void;
  openId: number;
}

export const ActionButton = ({
  id,
  onClick,
  open,
  setEditItemId,
  setDeleteItemId,
}: ActionButtonProps) => {
  return (
    <>
      <IconButton size='large' color='inherit' onClick={onClick} id={id}>
        <Iconify icon={'eva:more-vertical-fill'} />
      </IconButton>

      <Popover
        open={String(open?.id) === String(id)}
        anchorEl={open}
        onClose={onClick}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => {
            setEditItemId(Number(id));
          }}
        >
          <Iconify icon={'eva:edit-outline'} sx={{ mr: 1 }} />
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            setDeleteItemId(Number(id));
          }}
        >
          <Iconify icon={'eva:trash-outline'} sx={{ mr: 1 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
};
